import React from 'react';
import { TabsOrentations } from '../MTabs.model';

import MNTabsavItem from '../MTabsNavItem/MTabsNavItem';

import classes from './MTabsNav.module.scss';

type Props<Tabs extends string> = {
  activeTab: Tabs;
  classNameItem?: string;
  classNameItemSelected?: string;
  orientation?: TabsOrentations;
  className?: string;
  onTabClick: (tab: Tabs) => void;
};

const MTabsNavView = <Tabs extends string>(props: React.PropsWithChildren<Props<Tabs>>): JSX.Element => {
  return (
    <div
      className={`${classes['container']} ${props.className}  ${props.orientation === TabsOrentations.Vertical ? classes['container--vertical'] : ''}`.trim()}
    >
      {React.Children.map(props.children, (child: React.ReactNode) => (
        <MNTabsavItem
          id={child && child['props']['id']}
          key={child && child['props']['id']}
          active={(child && child['props']['id']) === props.activeTab}
          classNameItem={props.classNameItem}
          classNameItemSelected={props.classNameItemSelected}
          orientation={props.orientation}
          onTabClick={props.onTabClick}
        >
          {child && child['props']['text']}
        </MNTabsavItem>
      ))}
    </div>
  );
};

MTabsNavView.displayName = 'MTabsNavView';

export default MTabsNavView;
